import { motion, useScroll, useSpring } from "framer-motion";

/**
 * Slim scroll-progress indicator pinned to the top of the viewport. Framer
 * Motion tracks page scroll and a spring smooths it so the bar eases with the
 * (Lenis-smoothed) scroll rather than snapping frame to frame.
 */
export default function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 30, mass: 0.25 });

  return <motion.div className="scroll-progress" style={{ scaleX }} aria-hidden />;
}
